import { render } from "./GroupsManager.vue?vue&type=template&id=239a4ffe"
import script from "./GroupsManager.vue?vue&type=script&lang=js"
export * from "./GroupsManager.vue?vue&type=script&lang=js"

import "./GroupsManager.vue?vue&type=style&index=0&id=239a4ffe&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__